<script>
  import ParametersItem from './ParametersItem'

  export default {
    name: 'Parameters',
    components: {
      ParametersItem
    },
    props: {
      parametersDisplay: Array
    },
    data() {
      return {
        parameters: this.parametersDisplay
      }
    },
    watch: {
      parametersDisplay(newValue) {
        this.parameters = newValue;
      }
    },
    methods: {
      filter(event) {
        const VALUE = event.target.value;
        this.parameters = this.parametersDisplay.filter(function(item) {
          return item.NOME.toLowerCase().indexOf(VALUE.toLowerCase()) >= 0;
        });
      }
    }
  }
</script>

<template>
  <div class="parameters">
    <div class="parameters__item-search">
      <div class="field field--medium">
        <svg class="field__icon field__icon--left" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
        <input type="text" @input="filter" class="field__entry" placeholder="Procurar por parâmetro">
      </div>
    </div>
    <div v-if="parameters.length > 0">
      <ParametersItem
        v-for="(item, index) in parameters"
        :key="index"
        :parametersItem="item"
      >
      </ParametersItem>
    </div>
    <div 
      v-else
      class="parameters__select-category"
    >
      <img src="../assets/img/select-category.svg" alt="" width="140" height="174">
      <span>Selecione uma categoria</span>
    </div>

  </div>
</template>

<style scoped>
  .field {
    width: 100%;
    display: block;
    padding: 1.5rem 1.5rem 0 1.5rem;
    position: relative;
  }
  .field--medium .field__entry {
    padding: calc(.75rem - .5px) 1rem;
  }
  .field__entry {
    width: 100%;
    border: 0;
    border-bottom: 1px solid #ced4da;
    font-size: 1rem;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    color: #495057;
    font-size: .875rem;
    line-height: 1rem;
    resize: vertical;
  }
  .field__entry:focus {
    outline: none;
    border-bottom-color: #1C7ED6;
  }
  .field__icon {
    position: absolute;
    fill: #868e96;
    display: block;
    width: 1.5rem;
    height: 1.5rem;
  }
  .field__icon--left {
    left: 1.5rem;
  }
  .field--medium .field__icon {
    transform: translateY(.5rem);
  }
  .field--medium .field__icon--left + .field__entry {
    padding-left: calc(1rem + 1.5rem + 1rem);
  }
  ::-webkit-input-placeholder  {color: #ced4da;}
  input:-moz-placeholder {color: #ced4da;}


  .parameters {
    flex-grow: 1;
    max-width: 40rem;
    margin: 0 auto;
    position: relative;
  }
  .parameters__item-search {
    margin: 0 1.5rem 0 1.5rem; 
  }
  .parameters__item {
    margin: 3rem;
    overflow: hidden;
    border-radius: .25rem;
    position: relative;
  }
  .parameters__item::before {
    content: '';
    position: absolute;
    width: 1px;
    height: 100%;
    background: #DEE2E6;
    left: .75rem;
    top: 0;
  }
  .parameters-descrition {
    display: flex;
    flex-flow: row nowrap;
  }
  .parameters-descrition__order {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    font-weight: 500;
    font-size: .750em;
    line-height: 1.5rem;
    color: #868E96;
    text-align: center;
    border-radius: 50%;
    background: #F8F9FA;
    box-shadow: inset 0 0 0 1px #DEE2E6;
    position: relative;
  }
  .parameters-descrition__order::before {
    content: '';
    position: absolute;
    width: 1px;
    height: 100vh;
    background: #DEE2E6;
    left: 50%;
    top: 1.5rem;
  }
  .parameters-descrition__title {
    display: inline-block;
    color: #495057;
    font-size: .875rem;
    line-height: 1rem;
    margin-top: .250rem;
    margin-bottom: .750em;
    margin-left: 2rem;
    flex-grow: 1;
  }
  .parameters-descrition__quantity {
    display: inline-block;
    color: #868E96;
    font-size: .750em;
    line-height: 1rem;
    margin-top: .250rem;
  }

  .parameters-bars {
    margin-left: 3.5rem;
  }
  .parameters-bars__item {
    height: 2rem;
    padding: 0 1rem;
    background: #F8F9FA;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .parameters-bars__item__title,
  .parameters-bars__item__quantity {
    font-size: .750em;
    line-height: .875rem;
    color: #868E96;
    text-transform: uppercase;
    font-weight: 500;
  }

  .parameters__select-category {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    padding-top: 10rem;
    color: #495057;
    font-size: .875rem;
    line-height: 1rem;
  }
  .parameters__select-category span {
    width: 100%;
    text-align: center;
    margin-top: 1.5rem;
  }
</style>


